/**
 * MiniPlayer — thin bar above the bottom nav while a Deep Rest is loaded, so
 * the user can open the plan or the coach and keep listening.
 */

import { Play, Pause, X, Moon } from 'lucide-react';
import { useRestPlayer, fmtTime } from '../lib/restPlayer';

export default function MiniPlayer() {
  const p = useRestPlayer();
  if (!p || !p.session) return null;
  const pct = p.duration ? Math.min(100, (p.time / p.duration) * 100) : 0;
  return (
    <div className="border-t border-indigo-900/40 bg-slate-900/95 backdrop-blur px-3 py-2">
      <div className="max-w-3xl mx-auto flex items-center gap-3">
        <button
          onClick={p.toggle}
          aria-label={p.playing ? 'Pause' : 'Play'}
          className="w-9 h-9 rounded-full bg-indigo-600 hover:bg-indigo-500 text-white flex items-center justify-center flex-shrink-0"
        >
          {p.playing ? <Pause size={16} /> : <Play size={16} className="ml-0.5" />}
        </button>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 text-xs text-slate-200 truncate">
            <Moon size={12} className="text-indigo-400 flex-shrink-0" />
            <span className="truncate">{p.session.title || 'Deep Rest'}</span>
            <span className="text-slate-500 flex-shrink-0">{fmtTime(p.time)} / {fmtTime(p.duration)}</span>
          </div>
          <div className="mt-1 h-1 bg-slate-800 rounded-full overflow-hidden">
            <div className="h-full bg-indigo-500 rounded-full" style={{ width: `${pct}%` }} />
          </div>
        </div>
        <button onClick={p.stop} aria-label="Close player" className="p-1.5 text-slate-500 hover:text-slate-300 flex-shrink-0">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
